import { ColoursObj, getContrastYIQ, Icon } from "@eventr/common-storybook";
import { Tab, Tabs } from "@mui/material";
import i18n from "i18n/i18next";
import { SyntheticEvent, useCallback } from "react";
import { useHomeTab, useHomeTabStore } from "state/itineraryState/homeTab.store";
import {
  getIdentifierFromHomeTab,
  getTranslationKeyFromHomeTab,
  homeTabs,
  THomeTab,
} from "state/itineraryState/homeTabs";
import { useLiveLocationStore } from "state/liveLocationState/liveLocation.store";
import { useShallow } from "zustand/react/shallow";

export const HomeTabs = () => {
  const homeTab = useHomeTab();

  const onChange = useCallback((event: SyntheticEvent<Element, Event>, newValue: THomeTab) => {
    event.stopPropagation();

    useHomeTabStore.getState().setHomeTab(newValue);
  }, []);

  return (
    <Tabs
      value={homeTab}
      onChange={onChange}
      variant="fullWidth"
      indicatorColor="secondary"
      sx={{ minHeight: "44px", height: "44px" }}
    >
      {homeTabs.map((tab) => {
        const isSelected = homeTab === tab;
        const translationKey = getTranslationKeyFromHomeTab(tab);
        const tabIdentifier = getIdentifierFromHomeTab(tab);

        return (
          <Tab
            id={tabIdentifier}
            disableRipple
            disableFocusRipple
            label={i18n.t(translationKey)}
            value={tab}
            key={tab}
            sx={{
              minHeight: "44px",
              height: "44px",
              textTransform: "none",
              fontFamily: isSelected ? "Inter-600-900" : "Inter-100-500",
              fontWeight: 400,
              color: getContrastYIQ(ColoursObj.backgrounds.header),
              "&.Mui-selected": {
                color: getContrastYIQ(ColoursObj.backgrounds.header),
              },
              gap: "4px",
            }}
            icon={tab === "map" ? <ShareLocationIcon /> : undefined}
            iconPosition="end"
          />
        );
      })}
    </Tabs>
  );
};

function ShareLocationIcon() {
  const sharingStaleTimestamp = useLiveLocationStore(useShallow((s) => s.sharingStaleTimestamp));
  const sharingIsActive = typeof sharingStaleTimestamp === "number" && sharingStaleTimestamp > Date.now();

  if (!sharingIsActive) return null;

  return <Icon name="Share_Location" iconColour={ColoursObj.states.success} />;
}
